import {
  CardBlock,
  DateRangeInputBlock,
  InputBlock,
  InputValidation,
  NoCodeComponentBlock,
  evaluateSelector,
} from '@coast/schemas';
import { FormikErrors } from 'formik';
import moment from 'moment';
import { defaultEvaluationContext } from '@shared/components/blocks/utils/tokens';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { CommonFields, Fields } from '../types';
import { noCodeValidate } from './noCodeValidate';

function isValid(value: any, validation: InputValidation | undefined): boolean {
  if (Number.isNaN(value)) {
    return false;
  }
  if (!validation) {
    return true;
  }
  if (!!validation.regex && !new RegExp(validation.regex).exec(value)) {
    return false;
  }
  if (!!validation.min && value?.length < validation.min) {
    return false;
  }
  if (!!validation.max && value?.length > validation.max) {
    return false;
  }
  return true;
}

function isRequiredButEmpty(required: boolean, value: any): boolean {
  return required && !value;
}

export function validateBlocks(
  blocks: CardBlock[],
  workflowTemplate: API.WorkflowTemplateFragment | undefined,
  values: Fields & CommonFields,
): FormikErrors<Fields & CommonFields> {
  const errors: FormikErrors<Fields & CommonFields> = {};
  blocks
    // @ts-expect-error -- strict migration
    .filter((block: InputBlock | DateRangeInputBlock) =>
      // @ts-expect-error -- strict migration
      evaluateSelector(block.selector, values, defaultEvaluationContext),
    )
    // @ts-expect-error -- strict migration
    .forEach((block: InputBlock | DateRangeInputBlock | NoCodeComponentBlock) => {
      switch (block.type) {
        case 'input':
          if (
            // @ts-expect-error -- strict migration
            isRequiredButEmpty(block.required, values[block.name]) ||
            !isValid(values[block.name], block.validation)
          ) {
            errors[block.name] = block.validation?.message || i18n('card.blocks.input.error');
          }
          break;
        case 'date-range-input':
          const startDateFieldName = block.startDateFieldName ?? 'startDate';
          const endDateFieldName = block.endDateFieldName ?? 'endDate';

          const startDate = values[startDateFieldName];
          const endDate = values[endDateFieldName];
          if (!startDate) {
            errors[startDateFieldName] = i18n('card.blocks.dateRangeInput.startDateError');
          }
          if (!endDate) {
            errors[endDateFieldName] = i18n('card.blocks.dateRangeInput.endDateError');
          }
          if (moment(endDate).isBefore(startDate)) {
            errors['endDate'] = i18n('card.blocks.dateRangeInput.rangeError');
          }
          break;
        case 'no-code':
          const component = workflowTemplate?.components.find(c => c.id === block.componentId);
          const { isValid: isComponentValueValid, errorMessage } = noCodeValidate({
            // @ts-expect-error -- strict migration
            componentType: component.type,
            value: values[block.componentId],
          });
          if (!isComponentValueValid) {
            // @ts-expect-error -- strict migration
            errors[block.componentId] = errorMessage;
          }
          break;
        default:
          break;
      }
    });
  return errors;
}
